'use client';

import { useState } from 'react';
import { UnstyledButton } from '../ButtonV2/Button';
import { CaretUp } from '../../icons/icons/Navigation/CaretUp';
import { CaretDown } from '../../icons/icons/Navigation/CaretDown';
import clsx from 'clsx';
import { Subtotal, type SubtotalLine } from '../Subtotal/Subtotal';
import { useTranslation } from '@whoop/i18n/lang/client';
interface WYWPriceBreakdownProps {
  priceBreakdown: SubtotalLine[];
}
export function WYWPriceBreakdown({
  priceBreakdown
}: WYWPriceBreakdownProps) {
  const [showPriceBreakdown, setShowPriceBreakdown] = useState(false);
  const {
    t
  } = useTranslation('whoopYourWay');
  return <>
      <UnstyledButton className='flex flex-row items-center gap-1 pt-3.5' onClick={() => setShowPriceBreakdown(!showPriceBreakdown)} data-sentry-element="UnstyledButton" data-sentry-source-file="WYWPriceBreakdown.tsx">
        <span className='text-base font-normal'>{t('priceBreakdown')}</span>
        {showPriceBreakdown ? <CaretUp fill='black' height={16} title='close price breakdown' width={16} /> : <CaretDown fill='black' height={16} title='open price breakdown' width={16} />}
      </UnstyledButton>
      {showPriceBreakdown ? <div className={clsx('mt-3.5 max-w-[350px] rounded-lg bg-white px-6 py-3 shadow-[0_0_24px_0_rgba(0,0,0,0.1)]')}>
          <Subtotal lines={priceBreakdown} />
        </div> : null}
    </>;
}